<xemex-dialog-shell
  [title]="
    mode === 'add'
      ? ('devices.detailTabs.configuration.titleAddSubDevice' | translate)
      : ('devices.detailTabs.configuration.titleChannelDetails' | translate) + ' #' + channelNumber
  "
>
  <div class="border border-border-card rounded-lg p-2">
    <div class="p-2 flex flex-col">
      @if (protocol !== 'DLMS') {
        <mat-form-field floatLabel="always">
          <mat-label>{{ 'devices.detailTabs.configuration.category' | translate }}</mat-label>
          <mat-select [(ngModel)]="categoryId" (selectionChange)="onCategoryChange($event)">
            @for (item of categories; track item) {
              <mat-option [value]="item.id">
                <div class="flex items-center gap-2">
                  <span class="text-body font-bold">{{ item.name }}</span>
                </div>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (isLoadingDeviceConfigurations) {
        <div class="flex justify-center items-center">
          <xemex-spinner size="sm"></xemex-spinner>
        </div>
      } @else if (deviceConfigurations.length === 0) {
        <p class="text-sm text-gray-500 py-2">
          {{ 'devices.detailTabs.configuration.noDeviceConfigsAvailable' | translate }}
        </p>
      } @else {
        <mat-form-field>
          <mat-label>{{
            'devices.detailTabs.configuration.deviceConfigurationFile' | translate
          }}</mat-label>
          <mat-select
            [(ngModel)]="configurationFileId"
            (selectionChange)="onDeviceConfigurationFileIdChange()"
          >
            <mat-select-trigger>
              @for (d of deviceConfigurations; track d) {
                @if (d.fileId == configurationFileId) {
                  {{ d.description }}
                }
              }
            </mat-select-trigger>
            @for (item of deviceConfigurations; track item) {
              <mat-option [value]="item.fileId">
                <div class="flex items-center gap-2">
                  <span class="text-body font-bold">{{ item.description }}</span>
                  <span class="text-sm font-medium">{{ item.fileName }}</span>
                </div>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (getAllSubdeviceNames().length > 0) {
        <div class="text-lg font-semibold pb-4 mt-5">
          {{ 'devices.detailTabs.configuration.dynamicParameters' | translate }}:
        </div>
        <div class="flex flex-col">
          @for (subdeviceName of getAllSubdeviceNames(); track subdeviceName) {
            <div class="text-base font-medium pb-2">{{ subdeviceName }}</div>
            @for (param of dynamicParameters; track param.deviceName + '|' + param.name) {
              @if (param.deviceName == subdeviceName) {
                <mat-form-field>
                  <mat-label>{{ translateParameterName(param.name) }}</mat-label>
                  <input type="text" matInput [(ngModel)]="param.value" />
                </mat-form-field>
              }
            }
            @for (subDevice of subDevices; track subDevice.deviceName) {
              @if (subDevice.deviceName == subdeviceName) {
                @for (interface of subDevice.interfaces; track interface) {
                  @if (interface.name == 'emeter' && interface.context.target == null) {
                    <mat-form-field floatLabel="always">
                      <mat-label>{{
                        'devices.detailTabs.configuration.context.label' | translate
                      }}</mat-label>
                      <input
                        type="text"
                        matInput
                        placeholder="(Grid)"
                        [(ngModel)]="interface.context.label"
                      />
                      <mat-hint>{{
                        'devices.detailTabs.configuration.context.hint' | translate
                      }}</mat-hint>
                    </mat-form-field>
                  }
                }
              }
            }
          }
        </div>
      }
    </div>
  </div>
  @if (sendError) {
    <span class="text-red-500 text-sm max-w-sm">{{ sendError }}</span>
  }
  <div actions class="flex items-center gap-2">
    @if (succeeded) {
      <span class="flex items-center gap-1 text-green-600">
        <mat-icon>check_circle</mat-icon>
        {{ 'devices.detailTabs.configuration.sendSuccess' | translate }}
      </span>
      <xemex-outlined-button type="button" intent="primary" (click)="dialogRef.close()">
        {{ 'devices.detailTabs.configuration.closingIn' | translate: { seconds: countdown } }}
      </xemex-outlined-button>
    } @else {
      <xemex-text-button
        type="button"
        intent="primary"
        [disabled]="isSending"
        (click)="onChange('cancel')"
      >
        {{ 'general.btnCancel' | translate }}
      </xemex-text-button>
      <xemex-filled-button
        type="button"
        intent="primary"
        [loading]="isSending"
        [disabled]="!isValid() || isSending"
        (click)="onChange('deviceConfig')"
      >
        @if (isSending) {
          <xemex-spinner size="sm"></xemex-spinner>
        } @else {
          {{
            (mode === 'add'
              ? 'general.btnAdd'
              : 'devices.detailTabs.configuration.buttonChangeDeviceConfiguration'
            ) | translate
          }}
        }
      </xemex-filled-button>
    }
  </div>
</xemex-dialog-shell>
